cacheSlot